import { Loader } from '@hivebrite/design-system/Loader';

import type { PageIdentifier } from 'hb-react/shared/constants/pageIdentifiers';
import { usePageConfigQuery } from 'hb-react/shared/hooks/usePageConfigQuery';
import type { AppPageConfig } from 'hb-react/types';

interface ChildFuncAttr {
  appPageConfig: AppPageConfig | undefined;
  isLoading?: boolean;
}

interface WithAppPageConfigProps {
  children: ({ appPageConfig, isLoading }: ChildFuncAttr) => React.ReactNode;
  identifier: PageIdentifier;
  loader?: boolean;
}

export const WithAppPageConfig = ({
  children,
  identifier,
  loader,
}: WithAppPageConfigProps) => {
  const { data: page, isLoading } = usePageConfigQuery({ identifier });

  if (isLoading) {
    return loader ? <Loader /> : null;
  }

  return children({ appPageConfig: page, isLoading });
};
